import React from 'react';
import PropTypes from 'prop-types';
import ModalDialogMUI6 from 'src/components/ModalDialogMUI6';
import FormSelectNumberToCall from 'src/components/View/ModalDialogForm/SelectNumberToCall/FormSelectNumberToCall';
import { CONTACT_MODAL_FORM_NAMES } from 'src/constants/contacts';

function SelectNumberToCall({
  contact,
  onCloseModal,
  loading = false,
  visibleModalForm = '',
  onSubmitForm = null,
  onSubmitFormRequest = () => {},
}) {
  return (
    <ModalDialogMUI6
      onClose={onCloseModal}
      isVisible={visibleModalForm === CONTACT_MODAL_FORM_NAMES.MODAL_SELECT_NUMBER_TO_CALL}
      content={(
        <FormSelectNumberToCall
          loading={loading}
          contact={contact}
          onCloseModal={onCloseModal}
          onSubmitForm={onSubmitForm}
          onSubmitFormRequest={onSubmitFormRequest}
        />
      )}
      title="Select a Number to Call"
      loading={loading}
      okText="Call"
      onOk={() => {}}
      okButtonProps={{
        form: 'formSelectNumberToCall',
        type: 'primary',
      }}
      buttonsListOrder={['ok']}
    />
  );
}

SelectNumberToCall.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired,
  onSubmitForm: PropTypes.func,
  onSubmitFormRequest: PropTypes.func,
  loading: PropTypes.bool,
  visibleModalForm: PropTypes.string,
};

export default SelectNumberToCall;
